export function cubicIn(t) {
  return t * t * t;
}
export function cubicOut(t) {
  return --t * t * t + 1;
}
export function cubicInOut(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-ease@1.0.6@d3-ease/src/cubic.js
// module id = 201
// module chunks = 0 1 2